export default {
  logout: 'LOG OUT',
  permission_application: 'Permission application',
  dbh_country: 'Country',
  dbh_cascader_select_placeholder: 'Select',
  dbh_cascader_select_first_level_title: 'Category',
  dbh_cascader_select_second_level_title: 'Subcategory',
  dbh_cascader_select_overall_title: 'Overall',
  dbh_region_cascader_select_placeholder: 'Select Country',
  dbh_region_cascader_select_region: 'Region',
  dbh_region_cascader_select_multi_country: 'Go to the Multi-Country Page',
  dbh_confirm: 'Confirm',
  dbh_cancel: 'Cancel',
  dbh_save_img: 'Save Image',
  dbh_copy_img: 'Copy Image',
  dbh_network_error_msg: 'Network error',
  dbh_compress_image_error_msg: 'Image compress error',
  dbh_unknow_error_msg: 'Unknow error',
  dhh_back_old_version: 'Old Version',
  dhh_nav_bubble_dashboard_intro:
    'Dashboard: View the performance data of your games. The data comes from the game telemetry and is accurate data. ',
  dhh_nav_bubble_benchmark_intro: 'Benchmark: View industry benchmark data. ',
  dhh_nav_bubble_intelligence_intro:
    'Intelligence: To view competitor, industry data, and game trends. The data comes from external sources, and there may be some deviation from the actual data.',
  dhh_nav_bubble_intelligence: 'The new visual of Intelligence is under design, click to jump to the old version',
  dhh_nav_bubble_opinions_intro: "Opinions: Check the public feedback for your game and your game's competitors.",
  dhh_nav_bubble_opinions: 'The new visual of Opinions is under design, click to jump to the old version',
  dhh_nav_bubble_globalpedia_intro:
    'G-POP: IEGG Portfolio Operation Pipeline, Online presentation of operational management, strategy, pipeline, studio management, financial information, and workflow processing.',
  dhh_nav_bubble_globalpedia: 'The new visual of GPOP is under design, click to jump to the old version',
  dhh_nav_bubble_chatgpt:
    'ChatGPT-IEGG, powered by IEGG ADG NLP Team. Any feedback please contact Masonqliu or Bruceang.',
  db_loading: 'Loading...',

  dbh_recommendation_nolonger_displayed: 'This recommendation is no longer displayed',
  dbh_home_new_reports: 'New Reports',
  dbh_home_top_popular_reports: 'Top Popular Reports',
  dbh_home_public_true_data: 'Latest Public True Data Contribution',
  dbh_home_public_true_search_key: 'Search for game, date, metric, contributor and all',
  dbh_home_public_true_all_data: 'All True Data',
  dbh_home_public_true_data_more: 'More',
  dbh_home_true_data_contribute: 'I want to share',
  dbh_AI_error_tips: 'Recognition failed. Please try again',
  dbh_all_view_true: 'View all True Data',
  dbh_AI_error_tips_overlimit: 'The system is busy. Please try again later.',
  dbh_home_true_data_once: 'Vague time',
  dbh_home_top_eye_catching_Authors: 'Top Eye-Catching Authors',
  dbh_home_top_prolific_authors: 'Top Prolific Authors',
  dbh_home_top_active_data_lovers: 'Top Active Data Lovers',
  dbh_home_game_data_lover_leaderboard: 'Game Data Lover Leaderboard',
  dbh_home_report_views: 'Report Views',
  dbh_home_report_articles: 'Articles',
  dbh_home_report_active_value: 'Active Value',
  dbh_home_report_first_step:
    'Your search appears related to a company. You’ve been redirected to the <strong>Company Search</strong> page. Click ',
  dbh_home_report_second_step: ' to continue searching for games.',
  dbh_cancel_small: 'cancel',
  dbh_session_expired: 'Session expired. Please refresh the page to reload the dashboard.',
  dbh_table_not_complete: 'The corresponding dashboards are currently unavailable. Please stay tuned.',
  dbh_new: 'NEW',
  dbh_user_center: 'User Center',
  dbh_uploader_placeholder_text1: 'Click here to Upload or drag your files here',
  dbh_uploader_placeholder_text2: 'Accepted files types: {fileTypes} under {sizeLimit}',
  dbh_report_uploader_placeholder_desc: 'Accepted file types: Word, PDF, PPT, PPTX, HTML, ZIP file',
  dbh_report_uploader_placeholder_html_zip_tips:
    'If your HTML references external JS/CSS/images, we recommend uploading them as a compressed archive.',
  dbh_report_uploader_ai_unsupported_tips: 'AI autofill not supported for this file. Please enter manually.',
  dbh_uploader_dragging_placeholder_text: 'Drop any file here',
  // AI Search 相关
  dbh_ai_search: 'AI Search',
  dbh_ai_search_agent_smart_qa: 'Agent Smart QA',
  dbh_ai_search_page_navigation: 'DataBrain Page AI Navigation',
  dbh_ai_search_agent_smart_qa_hover: 'Integrates DataBrain Dashboard, Intelligence and Opinions data to deliver comprehensive game and industry insights',
  dbh_ai_search_page_navigation_hover: 'Briefly describe the DataBrain page you want to visit, and click to go there',
  dbh_ai_search_switch_open_hover: 'Click to activate AI Search for Agent smart QA or DataBrain Page AI Navigation',
  dbh_ai_search_switch_enabled_hover: 'AI Search for Agent smart QA or DataBrain Page AI Navigation. Click to turn off AI Search.',
  dbh_ai_search_switch_close_hover: 'Click to close AI Search',
  dbh_ai_search_input_placeholder: 'Describe your search. Ask Brainy, click to page',
  dbh_ai_search_input_simple_placeholder: 'Ask Brainy',
  dbh_ai_search_page_navigating: 'Navigating to the page for you...',
  dbh_ai_search_page_not_found: 'Unable to find the DataBrain page. Please check and modify your search terms, then try again. If you have any questions, feel free to contact sallyxue@tencent.com',
  dbh_ai_search_page_back_to_search: 'Back to Search',
  dbh_ai_search_page_navigated: 'You have been navigated to the page',
  dbh_ai_search_page_navigated_without_filters: 'You have been navigated to the page. This page does not support the selection of filters. Please manually set the filters.',
  dbh_ai_search_games: 'Games',
  dbh_not_found_title: 'Unrecognized Link',
  dbh_not_found_desc: "The system doesn't recognize the format of the link you entered. Please verify the link and try again.",
  authpath_error_no_report: 'Report info not found',
  authpath_error_no_game: 'Game info not found',
  authpath_error_menu_mismatch: 'Menu not matched',
  authpath_error_no_url: 'Report URL not found',
  authpath_error_token_empty: 'Failed to get auth token',
  authpath_error_fetch_failed: 'Failed to get authentication info',
  dbh_pr_trend_toggle_event: 'Event',
};
